(function ($) {
    $.fn.responsiveImg = function () {

        return this.each(function () {

            var container = $(this),
                imgs = container.find('img');

            imgs.each(function () {
                var img = $(this);

                if(img.parents('.gallery').length) return true;
                if(img.hasClass('notResponsive')) return true;

                img.removeAttr("height");

            });

        });

    };
})(jQuery);

